module.exports = __webpack_public_path__ + "static/media/dissatisfied.eca2e4ff.svg";